<!-- <app-loader class="loader-wrap active" *ngIf="loading"></app-loader> -->

<div class="wrapper mat-elevation-z2">
  <table mat-table [dataSource]="tableData" class="datagrid">
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox *ngIf="select==='multiple'&& isSelectAllEnabled" (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()"
          color="primary">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" [disabled]="row[disableSelect]<1"
          (change)="$event ? selectionChanged(row) : null" [checked]="selection.isSelected(row)" color="primary">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="{{col.colKey}}" *ngFor="let col of columns">
      <th mat-header-cell *matHeaderCellDef> {{col.colName}} </th>
      <td mat-cell *matCellDef="let item; let i=index;" (click)="selectionChanged(item, col)"
        [ngClass]="{ 'fix-content' : col.isDescriptive}" [matTooltip]="item[col.colKey]"
        [matTooltipDisabled]="!col.isDescriptive" matTooltipPosition="below" matTooltipClass="sl-tooltip">

        <!-- Simple Data Values -->
        <ng-container *ngIf="!(col.colKey === 'action') && !col.incDec && !col.image">
          <ng-container *ngIf="col.date">
            {{ item[col.colKey] | date:'MMM y'}}
          </ng-container>
          <ng-container *ngIf="col.fullDate">
            {{ item[col.colKey] | date}}
          </ng-container>
          <ng-container *ngIf="col.amount">
            {{ item[col.colKey] | currency :'INR':'symbol':'1.2-2'}}
          </ng-container>
          <ng-container *ngIf="!(col.date || col.amount || col.fullDate)">
            {{ item[col.colKey] }}
          </ng-container>
        </ng-container>

        <!-- For Row with Image -->
        <div class="image-wrap" *ngIf="col.image">
          <img [src]="item[col.colKey] ? http.baseUrlHotel + item[col.colKey]: getProfileImage(item)">
        </div>

        <!-- Actionable Items -->

        <!-- For Row Action Types -->
        <ng-container *ngIf="col.colKey === 'action' && !col.incDec && !col.image">
          <app-row-actions (emitAction)="triggerAction($event, item )" [actionTypes]="col.actions"
            [disabledActions]="col.condition?.includes(item[col.check2]) || col.condition?.includes(item[col.check])? col.disabledActions : []">
          </app-row-actions>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="noData">
      <td mat-footer-cell *matFooterCellDef [attr.colspan]="select? columns.length + 1 : columns.length"
        class="text-center noRecords">
        <div class="placeholder-image"></div>
        No Records Found...!
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="
    (row[disableSelect]<1)? 'notAvailable': selection.isSelected(row)? 'selected':'' ">
    </tr>
    <!--
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [style.backgroundColor]="colorKey?row[colorKey]:''"
      [ngClass]="colorKey? 'coloredRow':checkKeyForDisable ?
    row[checkKeyForDisable] === disableValue ? 'notAvailable': selection.isSelected(row)? 'selected':'' :''">
    </tr> -->

    <tr mat-footer-row *matFooterRowDef="['noData']" class="noData"
      [style.display]="tableData.data.length? 'none':'table-row'">
    </tr>
  </table>
</div>
<!-- <mat-paginator *ngIf="pagination" class="datagrid-footer" #paginator [length]="total" [pageSize]="limit"
  [pageSizeOptions]="pageLimit" (page)="refresh($event)" showFirstLastButtons>
</mat-paginator> -->
